import * as _ from 'lodash';

import { ActiveFormActions } from "./active-form.actions";
import { ProjectInterface as IProject } from '../../models/interfaces/project.interface';
import { Project } from '../../models/project.model';

export const initialState = {
  form: new Project(),
  isDirty: false,
};

export function ActiveFormReducer(state: { form: IProject, isDirty: boolean } = initialState, action) {

  switch (action.type) {
    case ActiveFormActions.SET_FORM:
      state.form = _.cloneDeep(action.payload.project);
      return state;

    case ActiveFormActions.SET_FORM_STEP:
      if (!state.form[action.payload.step]) {
        state.form[action.payload.step] = {};
      }
      state.form[action.payload.step].completed = true;
      return state;

    case ActiveFormActions.SET_FORM_STATE:
      //
      state.form[action.payload.step].fields = action.payload.fields;
      state.form[action.payload.step].completed = action.payload.valid;
      return state;

    case ActiveFormActions.ADD_OR_UPDATE_MONSTER:
      for (let i in state.form.projectFormMonsters.fields.monsters) {
        if (state.form.projectFormMonsters.fields.monsters[i].id == action.payload.monster.id) {
          state.form.projectFormMonsters.fields.monsters[i] = action.payload.monster;
          return state;
        }
      }
      state.form.projectFormMonsters.fields.monsters.push(action.payload.monster);
      return state;

    case ActiveFormActions.SYNC_ACTIVE_PROJECT_ID:
      return { ...state, form: new Project({ ...state.form, id: action.payload.id, projectId: state.form.id }) };

    case ActiveFormActions.SYNC_ACTIVE_PROJECT_MONSTER_ID:

      const form = { ...state.form };
      form.projectFormMonsters.fields.monsters = state.form.projectFormMonsters.fields.monsters.map((monster) => {
        if (monster.id === action.payload.id || monster.fields.general.sampleCode === action.payload.monsterCode) {
          monster.id = action.payload.id;
        }
        return monster;
      });

      return { ...state, form: form };

    case ActiveFormActions.SET_DIRTY:
      return { ...state, form: new Project({ ...state.form, dirty: action.payload.dirty }) };

    case ActiveFormActions.DELETE_MONSTER:
      const deleteMonsterForm = { ...state.form };
      deleteMonsterForm.projectFormMonsters.fields.monsters = deleteMonsterForm.projectFormMonsters.fields.monsters.filter((monster) => {
        return monster.id !== action.payload.monsterId;
      })
      return { ...state, form: deleteMonsterForm };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/states/activeForm/active-form.reducer.ts